// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refereeReviewPage .readOnlyQuestions {
  background-color: white;
}
.refereeReviewPage .readOnlyQuestions hr {
  border-color: #d4d4d4;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/refereeReview/RefereeReview.less"],"names":[],"mappings":"AAEA;EAEE,uBAAA;AAFF;AAAA;EAKG,qBAAA;AAFH","sourcesContent":["@import (reference) '../../constants.less';\n\n.refereeReviewPage {\n\t.readOnlyQuestions {\n\t\tbackground-color: white;\n\n\t\thr {\n\t\t\tborder-color: @greyD4;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
